module.exports = __webpack_public_path__ + "img/mewwallet-logo.21d9c6cf.svg";